import React from 'react'
// import PropTypes from 'prop-types'

import { Col, Row, Switch, Tooltip, message } from 'antd'
// import { v4 as uuidv4 } from 'uuid'
import _, { isEmpty } from 'lodash'
import InputApp from './../inputs/InputApp'
import './../../ui.style.scss'
import InputNumberApp from './../inputs/InputNumberApp'
import RichText from './RichText'
import placeholderImage from './../../../../assets/images/default-image.jpg'
import { findFileExtension, generateCroppedThumbnail, getFileSize } from './../../../../util/util'
import TextAreaAppInput from './../inputs/TextAreaApp'
import AddImageModal from './AddImageModal'
import EditIcon from './../../general/icons/EditIcon'
import ButtonContainer from '../../general/buttons/ButtonContainer'
import PopoverConfirm from './../../feedback/PopoverConfirm'
import AddBucketConfigAppModal from './AddBucketConfigAppModal'
import { utilityService } from '../../../../services/UtilityService'
import EditImageModal from './EditImageModal'
import AddIcon from './../../general/icons/AddIcon'
import InformationIcon from './../../../ui/general/icons/InformationIcon'
import JsonArrayViewModal from '../../dataDisplay/JsonArrayViewModal'
// import EditButton from '../../general/buttons/EditButton'
import CopyLinkButton from '../../general/buttons/CopyLinkButton'
import BucketAppViewModal from '../../dataDisplay/BucketAppViewModal'
import moment from 'moment'
import DateTimePicker from 'components/ui/dataEntry/inputs/DatePicker'
import { DATE_TIME_TYPE, FILE_TYPE } from 'constants/general-constants'
import JsonEditor from 'components/ui/dataDisplay/JsonEditor'
import { getJsonEditorContent } from 'components/ui/dataDisplay/utils'
import CustomMetaFileModal from './CustomMetaFileModal'
import CustomMetaFileTypeIcon from './CustomMetaFileTypeIcon'
import CustomMetaFileUploadIcon from './CustomMetaFileUploadIcon'

const parentCompoent = 'edit-object-config-modal'
const DEFAULT_MODE_JSON_ARRAY = 'table'

class AddObjectContainer extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showAddIcon: false,
      selectedImgconfigIcon: null,
      showBucketAddIcon: false,
      selectedBucketconfigIcon: null,
      showBucketDetails: false,
      jsonEditorModes: {},
      isCustomMetaRichTextModalOpen: {}
    }
  }

  hideImgAddIcon = () => {
    this.setState({
      showAddIcon: false,
      selectedImgconfigIcon: null
    })
  }

  showImgAddIcon = (selectedImgconfigIcon) => {
    this.setState({
      showAddIcon: true,
      selectedImgconfigIcon: selectedImgconfigIcon
    })
  }

  hideBucketAddIcon = () => {
    this.setState({
      showBucketAddIcon: false,
      selectedBucketconfigIcon: null
    })
  }

  showBucketAddIcon = (selectedBucketConfigIcon) => {
    this.setState({
      showBucketAddIcon: true,
      selectedBucketconfigIcon: selectedBucketConfigIcon
    })
  }

  showImageDetails = (config, imageDetails, index) => {
    const { project, handleObjectDetailsChange, showImgEditorIcon, hideImgEditorIcon, showEditIcon,
      showImgEditor, selectedImgEditConfig, isWidget, isUpdateBlocked } = this.props
    let imageUrl
    if (imageDetails) {
      imageUrl = generateCroppedThumbnail(imageDetails, 214, 120, '16:9')
    }
    const category = imageDetails && imageDetails.category ? imageDetails.category.label : null
    const imageSize = getFileSize(imageDetails.fileSize)
    return <div className={project !== 'hyperion' || 'projectx' ? 'image-content' : 'image-content-hyperion'} key={index}>
      <div className='img-container'
        onMouseEnter={isWidget && !isUpdateBlocked ? () => config && config.isUpdatable === true ? showImgEditorIcon(config, imageDetails) : null : () => showImgEditorIcon(config, imageDetails)}
        onMouseLeave={hideImgEditorIcon}>
        {<img src={imageUrl} />}
        { (!isUpdateBlocked && showEditIcon && selectedImgEditConfig.name === config.name) ? <div onClick={showImgEditor} className='img-editor-icon'> <EditIcon /> </div> : null }
      </div>
      <div className='image-content-wrapper' key={index}>
        <div className='image-content-header'>
          {imageDetails.name.length > 15 ? <ButtonContainer displayTitle={imageDetails.name} childComponent={<p>{ imageDetails.name }</p>} /> : <p>{ imageDetails.name }</p> }
          <div className='image-content-btns'>
            {!isUpdateBlocked
              ? isWidget
                ? <PopoverConfirm
                  confirm={() => config && config.isUpdatable === true ? handleObjectDetailsChange(config, null) : null}
                  parentCompoent={parentCompoent}
                  isDisabled={config && config.isUpdatable !== true}
                />
                : <PopoverConfirm
                  confirm={() => handleObjectDetailsChange(config, null)}
                  parentCompoent={parentCompoent}
                  isDisabled={false}
                />
              : null
            }
          </div>
        </div>
        <div className='image-content-details'>
          <div className='image-info'>
            <p>Output Format:</p>
            <p> { findFileExtension(imageDetails.name) || 'JPG'}</p>
          </div>
          {category ? <div className={`image-info ${category ? '' : 'hidden'}`}>
            <p>Category:</p>
            <p>{category}</p>
          </div> : ''}
          <div className={`image-info ${imageSize ? '' : 'hidden'}`}>
            <p>Original File Size:</p>
            <p>{imageSize}</p>
          </div>
        </div>
      </div>
    </div >
  }

  showBucketDetails = (config, bucketDetails, index) => {
    const { handleObjectDetailsChange, isWidget, project, isUpdateBlocked } = this.props
    const { showBucketDetails } = this.state
    let isBucketPublished = bucketDetails && bucketDetails.isPublished
    let bucketId = bucketDetails && bucketDetails.id
    let copyLink = () => {
      var anchor = document.createElement('a')
      anchor.href = `${location.origin}/buckets/preview/${bucketId}`
      anchor.target = '_blank'
      document.body.appendChild(anchor)
      anchor.click()
    }
    const status = utilityService.getPublishStatus(bucketDetails.isPublished, bucketDetails.publishStartDate, bucketDetails.publishEndDate)
    return <div className={'bucket-content-hyperion'} key={index}>
      <div className='bucket-content-wrapper' key={index}>
        <div className='bucket-content-header'>
          { <a onClick={this.handlBucketDetails}>{ bucketDetails.name }</a> }
          <div className='bucket-content-btns'>
            <div className='preview-button'>
              <ButtonContainer displayTitle='View API Response' childComponent={<CopyLinkButton onClick={copyLink} isDisabled={!isBucketPublished} />} />
            </div>
            {!isUpdateBlocked
              ? isWidget
                ? <PopoverConfirm
                  confirm={() => config && config.isUpdatable === true ? handleObjectDetailsChange(config, null) : null}
                  parentCompoent={parentCompoent}
                  isDisabled={config && config.isUpdatable !== true}
                />
                : <PopoverConfirm
                  confirm={() => handleObjectDetailsChange(config, null)}
                  parentCompoent={parentCompoent}
                  isDisabled={false}
                />
              : null
            }
          </div>
        </div>
        <div className='bucket-content-details'>
          <div className='bucket-right-info'>
            <p>{ status }</p>
            <p>{bucketDetails.key}</p>
          </div>
          <div className='bucket-left-info'>
            <p>{bucketDetails.displayName }</p>
            <p>{bucketDetails.displayType && bucketDetails.displayType.name}</p>
          </div>
        </div>
      </div>
      <BucketAppViewModal
        isVisible={showBucketDetails}
        handleCancel={this.hideBucketDetails}
        bucketDetails={bucketDetails}
        project={project}

      />
    </div >
  }

  handleJsonArrayChange = (config, value) => {
    this.props.handleObjectDetailsChange(config, value)
  }

  getObjectMetaFields = (objectDetails, selectedAppConfig) => {
    const { handleObjectDetailsChange, project, handleShowAddImageModal, hideAddImageModal, saveCurrentImageSelection, showAddImageModal,
      handleShowBucketModal, showAddBucketModal, hideAddBucketModal, handleBucketSelection, selectedBucket, saveCurrentBucketSelection, showImgEditModal,
      hideImgEditor, selectedBucketConfig, selectedImgConfig, editImageDetails,
      // isJsonArrayValid,
      jsonInvalidEntries, isWidget, handleJsonArrayVisibilty, isUpdateBlocked, isConfigObjectSaveDisable, useFor } = this.props
    const { showAddIcon, selectedImgconfigIcon, selectedBucketconfigIcon, showBucketAddIcon, isCustomMetaRichTextModalOpen } = this.state
    const configFields = selectedAppConfig ? _.cloneDeep(selectedAppConfig) : []
    const image = placeholderImage

    return (configFields || []).map((config, index) => {
      const selectedMeta = (objectDetails || []).find(item => item.name === config.name && item.type === config.type)
      if (config.type === 'BOOLEAN') {
        return <div className={'switch-container'} key={index}>
          <div className='switch-inner-container'>
            <div><span>{config.name}</span>{config.isRequired ? <span className='mandatory'>*</span> : ''}
              {config && config.tooltipText ? <span id='info-icon'><Tooltip placement='right' childComponent={<div className='info-icon'><InformationIcon /></div>} description={config.tooltipText} parentCompoent='info-icon' /></span> : null }</div>
            <Switch checked={selectedMeta ? (selectedMeta.value === 'false' ? false : selectedMeta.value) : false} onChange={(value) => handleObjectDetailsChange(config, value)} disabled={(isWidget && config.isUpdatable !== true) || isUpdateBlocked} />
          </div>
        </div>
      } else if (config.type === 'STRING' && !config.useAsTitle) {
        return <InputApp
          key={index}
          title={config.name}
          placeholder={`Enter ${config.name}`}
          inputName='title'
          isRequired={config.isRequired}
          value={selectedMeta ? selectedMeta.value : ''}
          handleChange={({ target }) => handleObjectDetailsChange(config, target.value)}
          isError={selectedMeta ? selectedMeta.isError : false}
          errorMessage={''}
          readOnly={(isWidget && config.isUpdatable !== true) || isUpdateBlocked}
          tooltipText={config && config.tooltipText}
        />
      } else if (config.type === 'STRING' && isWidget) {
        return <InputApp
          key={index}
          title={config.name}
          placeholder={`Enter ${config.name}`}
          inputName='title'
          isRequired={config.isRequired}
          value={selectedMeta ? selectedMeta.value : ''}
          handleChange={({ target }) => handleObjectDetailsChange(config, target.value)}
          isError={selectedMeta ? selectedMeta.isError : false}
          errorMessage={''}
          readOnly={(isWidget && config.isUpdatable !== true) || isUpdateBlocked}
          tooltipText={config.tooltipText || null}
        />
      } else if (config.type === 'NUMBER') {
        return <InputNumberApp
          limit={16}
          key={index}
          title={config.name}
          placeholder={`Enter ${config.name}`}
          inputName='title'
          isRequired={config.isRequired}
          value={selectedMeta ? parseInt(selectedMeta.value) : null}
          handleChange={(value) => handleObjectDetailsChange(config, value)}
          isError={selectedMeta ? selectedMeta.isError : false}
          errorMessage={''}
          readOnly={(isWidget && config.isUpdatable !== true) || isUpdateBlocked}
          tooltipText={config.tooltipText || null}
        />
      } else if (config.type === 'RICHTEXT') {
        return <div className={`rich-text-container`} key={index}>
          <div><span>{config.name}</span>{config.isRequired ? <span className='mandatory'>*</span> : ''}
            {config && config.tooltipText ? <span id='info-icon'><Tooltip placement='right' childComponent={<div className='info-icon'><InformationIcon /></div>} description={config.tooltipText} parentCompoent='info-icon' /></span> : null }</div>
          <RichText key={config.id} id={config.id} text={selectedMeta ? selectedMeta.value : ''} onRichTextChange={value => handleObjectDetailsChange(config, value)} showCloseIcon={false} readOnly={(isWidget && config.isUpdatable !== true) || isUpdateBlocked} />
        </div>
      } else if (config.type === 'JSON') {
        return <div className={'summary-container'} key={index}>
          <TextAreaAppInput
            key={index}
            title={config.name}
            placeholder={`Enter ${config.name}`}
            inputName='title'
            value={selectedMeta ? selectedMeta.value : ''}
            jsonEditorValue={selectedMeta?.jsonEditorValue}
            isRequired={config.isRequired}
            isError={selectedMeta ? selectedMeta.isError : false}
            handleChange={(value, isConfigObjectSaveDisable) => handleObjectDetailsChange(config, value, isConfigObjectSaveDisable)}
            jsonInvalidEntries={jsonInvalidEntries}
            currentId={config.id}
            isEditable={!((isWidget && config.isUpdatable !== true) || isUpdateBlocked)}
            tooltipText={config.tooltipText || null}
            project={project}
            useFor={useFor}
            isConfigObjectSaveDisable={isConfigObjectSaveDisable}
          />
        </div>
      } else if (config.type === 'JSONARRAY') {
        return <div className={'json-array-summary-container json-array-editor-container'} key={index}>
          <div className='json-summary-header'>
            <div><label>{config.name}</label>
              {config.isRequired
                ? <span className='mandatory'>*</span> : ''}
              {config.tooltipText ? <span id='info-icon'>
                <Tooltip
                  placement='rightTop'
                  childComponent={<div className='info-icon'><InformationIcon /></div>}
                  description={config.tooltipText}
                  parentCompoent='info-icon' />
              </span> : null
              }
            </div>
            {/* <EditButton isDisabled={(isWidget && config.isUpdatable !== true) || isUpdateBlocked} onClick={() => handleJsonArrayVisibilty(config, selectedMeta)} /> */}
          </div>
          {/* <Table className={`json-array-table`} rowKey={record => record.id} columns={columns} dataSource={selectedJsonArrayTableValue} pagination={false} scroll={{ x: 1600, y: 240 }} /> */}
          <div
            className='json-editor-array-container'
            onClick={() => {
              const isDisabled = (isWidget && config.isUpdatable !== true) || isUpdateBlocked
              if (!isDisabled) {
                handleJsonArrayVisibilty(config, selectedMeta)
                this.setDefaultMode(getJsonEditorContent(selectedMeta?.value), config, DEFAULT_MODE_JSON_ARRAY)
              }
            }}
          >
            <JsonEditor
              content={getJsonEditorContent(selectedMeta?.value)}
              // onChange={(content) => {
              //   handleObjectDetailsChange(config, content, false)
              // }}
              // headerOptionsToRemove={JSON_EDITOR_HEADER_OPTIONS_TO_REMOVE}
              // onRenderContextMenu={(items, context) => {
              //   return this.handleContextMenuOptions(items, context)
              // }}
              readOnly
              mode={DEFAULT_MODE_JSON_ARRAY}
            />
          </div>
        </div>
      } else if (config.type === 'IMAGE') {
        let selectedImage = selectedMeta && selectedMeta.value
        return <React.Fragment key={index}>
          {!selectedImage
            ? (
              <div
                className={`image-container ${
                  selectedMeta && selectedMeta.isError ? 'error' : ''
                }`}>
                <div>
                  <span>{config.name}</span>
                  {config.isRequired ? <span className='mandatory'>*</span> : ''}
                  {config && config.tooltipText ? (
                    <span id='info-icon'>
                      <Tooltip
                        placement='right'
                        childComponent={
                          <div className='info-icon'>
                            <InformationIcon />
                          </div>
                        }
                        description={config.tooltipText}
                        parentCompoent='info-icon'
                      />
                    </span>
                  ) : null}
                </div>
                <div
                  className='image-container-thumb'
                  style={{ backgroundImage: `url(${image})` }}
                  onMouseEnter={() => this.showImgAddIcon(config)}
                  onMouseLeave={this.hideImgAddIcon}>
                  {isWidget && !isUpdateBlocked ? (
                    showAddIcon && selectedImgconfigIcon.name === config.name ? (
                      <div
                        onClick={() =>
                          config && config.isUpdatable === true
                            ? handleShowAddImageModal(config)
                            : null
                        }
                        className='img-add-icon'>
                        {' '}
                        <AddIcon />{' '}
                      </div>
                    ) : null
                  ) : showAddIcon && selectedImgconfigIcon.name === config.name ? (
                    <div onClick={() => handleShowAddImageModal(config)} className='img-add-icon'>
                      {' '}
                      <AddIcon />{' '}
                    </div>
                  ) : null}
                </div>
              </div>
            )
            : <div className='image-details'> <div><span>{config.name}</span>{config.isRequired ? <span className='mandatory'>*</span> : ''} {config && config.tooltipText ? <span id='info-icon'><Tooltip placement='right' childComponent={<div className='info-icon'><InformationIcon /></div>} description={config.tooltipText} parentCompoent='info-icon' /></span> : null} </div>{this.showImageDetails(config, selectedMeta.value, index)}</div>}
          <AddImageModal
            isMultiSelect={false}
            isVisible={showAddImageModal && !isUpdateBlocked}
            handleSubmit={(selectedImage) => saveCurrentImageSelection(selectedImgConfig, selectedImage)}
            handleCancel={hideAddImageModal}
            mediaType='IMAGE'
            isUpdateDisabled={false}
            isSubmitButtonDisabled={false}
            module='APP_MANAGER'
            project={project}
          />
          <EditImageModal
            type={'IMAGE'}
            isVisible={showImgEditModal && !isUpdateBlocked}
            hideImageEditor={hideImgEditor}
            imageId={editImageDetails && editImageDetails.id}
            mediaDetails={editImageDetails && editImageDetails}
            // query={queryParams}
            isUpdateBlocked={false}
            isUploadBlocked={false}
            project={project}
          />
        </React.Fragment>
      } else if (config.type === 'BUCKET') {
        let selectedBucketValue = selectedMeta && selectedMeta.value
        return <React.Fragment key={index}>
          {!selectedBucketValue ? <div className={`bucket-container  ${selectedMeta && selectedMeta.isError ? 'error' : ''}`} >
            <div><span>{config.name}</span>{config.isRequired ? <span className='mandatory'>*</span> : ''}
              {config && config.tooltipText ? <span id='info-icon'><Tooltip placement='right' childComponent={<div className='info-icon'><InformationIcon /></div>} description={config.tooltipText} parentCompoent='info-icon' /></span> : null }</div>
            <div className='bucket-container-thumb' style={{ backgroundImage: `url(${image})` }} onMouseEnter={() => !isUpdateBlocked ? this.showBucketAddIcon(config) : () => {}}
              onMouseLeave={this.hideBucketAddIcon} >
              {isWidget
                ? (showBucketAddIcon && selectedBucketconfigIcon.name === config.name)
                  ? <div onClick={() => config && config.isUpdatable === true ? handleShowBucketModal(config) : null} className='bucket-add-icon'> <AddIcon /> </div> : null
                : (showBucketAddIcon && selectedBucketconfigIcon.name === config.name)
                  ? <div onClick={() => handleShowBucketModal(config)} className='bucket-add-icon'> <AddIcon /> </div> : null
              }
            </div>
          </div>
            : <div className='bucket-details-config'>
              <div className='info-header'><span>{config.name}</span>
                {config.isRequired ? <span className='mandatory'>*</span> : ''}
                {config && config.tooltipText
                  ? <div id='info-icon'>
                    <Tooltip
                      placement='right'
                      childComponent={<div className='info-icon'><InformationIcon /></div>}
                      description={config.tooltipText}
                      parentCompoent='info-icon'
                    />
                  </div> : null }
              </div>
              {this.showBucketDetails(config, selectedMeta.value, index)}
            </div>
          }
          <AddBucketConfigAppModal
            isVisible={showAddBucketModal && !isUpdateBlocked}
            handleCancel={hideAddBucketModal}
            handleBucketSelection={handleBucketSelection}
            selectedBucket={selectedBucket}
            handleSave={() => saveCurrentBucketSelection(selectedBucketConfig)}
            project={project}
          />
        </React.Fragment>
      } else if (config.type === DATE_TIME_TYPE.value) {
        const dateValue = selectedMeta?.value
          ? moment(new Date(selectedMeta.value))
          : null
        return (
          <div className='bucket-details-config'>
            <Row gutter={[12, 12]} align='middle' justify='center' type='flex'>
              <Col span={12} className='bucket-details-heading-container'>
                <p className='bucket-details-heading'>{config.name}</p>
                {config.isRequired ? <span className='mandatory'>*</span> : ''}
                {config?.tooltipText && (
                  <span id='info-icon'>
                    <Tooltip
                      placement='right'
                      childComponent={
                        <div className='info-icon'>
                          <InformationIcon />
                        </div>
                      }
                      description={config.tooltipText}
                      parentCompoent='info-icon'
                    />
                  </span>
                )}
              </Col>
              <Col span={12}>
                <DateTimePicker
                  use12Hours={false}
                  date={dateValue}
                  dateFormat='DD MMM YYYY, hh:mm A'
                  onChange={(value) => handleObjectDetailsChange(config, value)}
                  placeholder='Select Date time'
                  // disabledTime={endDate ? () => this.disabledRangeTime('end') : () => this.disableTimeComplete()}
                  // disabledDate={this.disableEndDate}
                  // onOpenChange={(value) => this.onOpenChange(value, false)}
                  status={selectedMeta?.isError ? 'error' : ''}
                />
              </Col>
            </Row>
          </div>
        )
      } else if (config.type === FILE_TYPE.value) {
        const supportedFileTypes = config?.supportedFileTypes || []
        let selectedFile = selectedMeta?.file?.fileName
        const isModalOpen = isCustomMetaRichTextModalOpen[config.id] === true
        return (
          <React.Fragment key={index}>
            <div className='image-container file-item-container' >
              <div>
                <span>{config.name}</span>
                {config.isRequired ? <span className='mandatory'>*</span> : ''}
                {
                  config?.tooltipText && (
                    <Tooltip placement='right' title={config.tooltipText}>
                      <span className='asset-info-icon-boolean'>
                        <InformationIcon />
                      </span>
                    </Tooltip>
                  )
                }
              </div>
              {
                !isEmpty(selectedFile)
                  ? (
                    <CustomMetaFileTypeIcon
                      fileName={selectedFile}
                      onClear={() => handleObjectDetailsChange(config, '')}
                      meta={null}
                    />
                  )
                  : (
                    <>
                      <CustomMetaFileUploadIcon
                        onClick={() => {
                          this.setState({
                            isCustomMetaRichTextModalOpen: {
                              ...this.state.isCustomMetaRichTextModalOpen,
                              [config.id]: true
                            }
                          })
                        }}
                        toolTipTitle={supportedFileTypes?.join(', ')}
                      />
                      <CustomMetaFileModal
                        title='Select File'
                        project={this.props.project}
                        visible={isModalOpen}
                        onOk={(selectedItem) => {
                          console.log('selectedItem', selectedItem)
                          const fileName = selectedItem?.fileName
                          if (!fileName) {
                            message.error('Please select a valid file')
                          } else {
                            handleObjectDetailsChange(config, { id: selectedItem?.id, fileName })
                          }
                          this.setState({ isCustomMetaRichTextModalOpen: {} })
                        }}
                        onCancel={() => {
                          this.setState({
                            isCustomMetaRichTextModalOpen: {}
                          })
                        }}
                        rootFolderItemsToShow={supportedFileTypes}
                      />
                    </>
                  )
              }
            </div>
          </React.Fragment>
        )
      }
    })
  }

  getObjectMetaFieldsTitle = (objectDetails, selectedAppConfig) => {
    const configFields = selectedAppConfig ? _.cloneDeep(selectedAppConfig) : []
    const { handleObjectDetailsChange, isUpdateBlocked } = this.props
    return (configFields || []).map((config, index) => {
      const selectedMeta = (objectDetails || []).find(item => item.name === config.name && item.type === config.type)
      if (config.type === 'STRING' && config.useAsTitle) {
        return <InputApp
          key={index}
          readOnly={isUpdateBlocked}
          title={config.name}
          placeholder={`Enter ${config.name}`}
          inputName='title'
          isRequired={config.isRequired}
          value={selectedMeta ? selectedMeta.value : ''}
          handleChange={({ target }) => handleObjectDetailsChange(config, target.value)}
          isError={selectedMeta ? selectedMeta.isError : false}
          errorMessage={''}
          tooltipText={config.tooltipText || null}
        />
      }
    })
  }

  copyOnClick = (data, type) => {
    navigator.clipboard.writeText(data, type)
    message.success(`${type} Copied Successfully`)
  }

  handlBucketDetails = () => {
    this.setState({
      showBucketDetails: true
    })
  }

  hideBucketDetails = () => {
    this.setState({
      showBucketDetails: false
    })
  }

  setDefaultMode = (jsonEditorValue, config, DEFAULT_MODE) => {
    if (isEmpty(jsonEditorValue?.text || jsonEditorValue?.json)) {
      this.handleJsonEditorModes('text', config.id)
    } else {
      this.handleJsonEditorModes(DEFAULT_MODE, config.id)
    }
  }

  handleJsonEditorModes = (mode, id) => {
    this.setState(prevState => {
      return {
        ...prevState,
        jsonEditorModes: {
          ...prevState.jsonEditorModes,
          [id]: mode
        }
      }
    })
  }

  render () {
    const { objectDetails, details, isWidget, isWidgetEdit, jsonArrayInvalidEntries, handleObjectDetailsChange, isJsonArrayValid, handleJsonArrayHide,
      isJsonArrayVisible, jsonConfig, jsonSelectedMeta, project } = this.props
    const { jsonEditorModes } = this.state
    let fields = isWidget
      ? isWidgetEdit
        ? details.fieldValues
        : details.fields
      : details.fields
    const currentId = jsonConfig?.id
    const currentJsonArrayMode = jsonEditorModes?.[currentId] || DEFAULT_MODE_JSON_ARRAY
    return (
      <div id='edit-object-config-modal' className={`edit-object-config-modal`}>
        {!isWidget ? <div className='edit-object-config-title'>
          {this.getObjectMetaFieldsTitle(objectDetails, _.sortBy(details.fields, 'position'))}
        </div> : null}
        {!isWidget ? <div className='edit-object-config-parameters'>
          <p >Parameters</p>
          <hr />
        </div> : null}
        {this.getObjectMetaFields(objectDetails, _.sortBy(fields, 'position'))}
        {isJsonArrayVisible ? <JsonArrayViewModal
          key={jsonConfig.name}
          title={jsonConfig.name}
          placeholder={`Enter ${jsonConfig.name}`}
          inputName='title'
          value={jsonSelectedMeta ? jsonSelectedMeta.value : ''}
          jsonEditorValue={jsonSelectedMeta?.jsonEditorValue}
          isRequired={jsonConfig.isRequired}
          isError={jsonSelectedMeta ? jsonSelectedMeta.isError : false}
          handleChange={(value) => handleObjectDetailsChange(jsonConfig, value)}
          isJsonArrayValid={isJsonArrayValid}
          jsonArrayInvalidEntries={jsonArrayInvalidEntries}
          currentId={currentId}
          isVisible={isJsonArrayVisible}
          handleCancel={() => {
            handleJsonArrayHide()
            this.setDefaultMode(getJsonEditorContent(jsonSelectedMeta?.value), jsonConfig, DEFAULT_MODE_JSON_ARRAY)
          }}
          handleJsonArrayChange={this.handleJsonArrayChange}
          jsonConfig={jsonConfig}
          project={project}
          mode={currentJsonArrayMode}
          handleJsonEditorModes={this.handleJsonEditorModes}
        /> : null}
      </div>
    )
  }
}

AddObjectContainer.propTypes = {

}

AddObjectContainer.defaultProps = {
}

export default AddObjectContainer
